<template lang="pug">
  div#map-search.position-relative
    Map(gestureHandling="greedy")
</template>

<script>
import Map from '@/components/Map.vue'
export default {
  // コンポーネント
  components: {
    Map
  },
  created(){
  },
  mounted(){
    const ua = navigator.userAgent
    let mapEl = document.getElementById('map-search')
    let scrollY =  mapEl.getBoundingClientRect().top

    if(ua.indexOf('Trident') !== -1) {
      //IE 11の場合はナビがstickyにならないので、上いっぱいまで表示する。
      window.scrollBy(0,scrollY)
    }else{
      window.scrollBy(0,scrollY-62)
    }

    // PCでのスクロール禁止
    document.addEventListener("mousewheel", this.scroll_control, { passive: false });
    // スマホでのタッチ操作でのスクロール禁止
    document.addEventListener("touchmove", this.scroll_control, { passive: false });

  },
  destroyed(){
    // PCでのスクロール禁止解除
    document.removeEventListener("mousewheel", this.scroll_control, { passive: false });
    // スマホでのタッチ操作でのスクロール禁止解除
    document.removeEventListener('touchmove', this.scroll_control, { passive: false });
  },
  // メソッド
  methods: {
    scroll_control(event) {
      event.preventDefault();
    }
  }
}
</script>

<style lang="stylus" scoped>
  #map-search
    height calc(100vh - 137px)
</style>